import { Badge, Button } from '@ui/themed';
import { t } from 'i18next';
import { useContext } from 'react';
import { CollapseContext } from './collapse-context';
import type { CardBadge } from './types';

export function CardBadges({ badges }: { badges?: CardBadge[] }) {
  return badges?.map((badge) => (
    <Badge key={badge.text} variant={badge.variant} size="sm">
      {badge.text}
    </Badge>
  ));
}

/** Show/hide chevron for a collapsible card. Wix builds its own on `IconButton`. */
export function CollapseToggle() {
  const { showBody, setShowBody, bodyId } = useContext(CollapseContext);

  return (
    <Button
      variant="bare"
      aria-expanded={showBody}
      aria-controls={bodyId}
      aria-label={t('aria:toggle_card_body')}
      icon="chevronDown"
      onClick={() => setShowBody((prev) => !prev)}
    />
  );
}
